exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-3b129cf6]{color:darkred}", ""]);

// exports
